<template>
    <v-container fluid grid-list-xl class="pt-5 mt-5">
        <v-container justify-center fluid>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-layout row wrap justify-center>
                        <icon-base
                                class="py-2"
                                viewBox="0 0 881.5 397"
                                width="100%"
                                height="250px"
                        >
                            <icon-vorsi-logo/>
                        </icon-base>
                    </v-layout>
                </v-flex>

                <v-flex xs12 row wrap justify-center class="register-headline" dusk="tryForFreeHeadline"
                        style="max-width: 800px">
                    Register For Vorsi
                </v-flex>
            </v-layout>
        </v-container>
        <v-container row wrap justify-center style="max-width: 1200px">
            <v-card-actions>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="First Name"
                                    v-model="data.firstName"
                                    dusk="firstName"
                                    ref="firstName"
                                    color="primary"
                                    outline
                                    :error-messages="firstName_errors"
                                    @input="delayTouch($v.data.firstName)"
                                    @blur="$v.data.firstName.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Last Name"
                                    v-model="data.lastName"
                                    dusk="lastName"
                                    ref="lastName"
                                    color="primary"
                                    outline
                                    :error-messages="lastName_errors"
                                    @input="delayTouch($v.data.lastName)"
                                    @blur="$v.data.lastName.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Job Title"
                                    v-model="data.jobTitle"
                                    dusk="jobTitle"
                                    ref="jobTitle"
                                    color="primary"
                                    outline
                                    :error-messages="jobTitle_errors"
                                    @input="delayTouch($v.data.jobTitle)"
                                    @blur="$v.data.jobTitle.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Email"
                                    v-model="data.email"
                                    dusk="email"
                                    ref="email"
                                    color="primary"
                                    outline
                                    :error-messages="email_errors"
                                    @input="delayTouch($v.data.email)"
                                    @blur="$v.data.email.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Phone"
                                    v-model="data.phone"
                                    mask="(###) ### - #### a####"
                                    dusk="phoneNumber"
                                    ref="phone"
                                    color="primary"
                                    outline
                                    v-on:keypress="phoneKeyValidation($event)"
                                    :error-messages="phone_errors"
                                    @input="delayTouch($v.data.phone)"
                                    @blur="$v.data.phone.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Company"
                                    dusk="company"
                                    v-model="data.company"
                                    ref="company"
                                    color="primary"
                                    outline
                                    :error-messages="company_errors"
                                    @input="delayTouch($v.data.company)"
                                    @blur="$v.data.company.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs5 sm4>
                            <v-text-field
                                    label="Street Number"
                                    dusk="streetNumber"
                                    v-model="data.streetNumber"
                                    ref="streetNumber"
                                    color="primary"
                                    outline
                                    :error-messages="streetNumber_errors"
                                    @input="delayTouch($v.data.streetNumber)"
                                    @blur="$v.data.streetNumber.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs7 sm8>
                            <v-text-field
                                    label="Street Name"
                                    dusk="streetName"
                                    v-model="data.streetName"
                                    ref="streetName"
                                    color="primary"
                                    outline
                                    :error-messages="streetName_errors"
                                    @input="delayTouch($v.data.streetName)"
                                    @blur="$v.data.streetName.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="City"
                                    dusk="city"
                                    v-model="data.city"
                                    ref="city"
                                    color="primary"
                                    outline
                                    :error-messages="city_errors"
                                    @input="delayTouch($v.data.city)"
                                    @blur="$v.data.city.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="State"
                                    dusk="state"
                                    v-model="data.state"
                                    ref="state"
                                    color="primary"
                                    outline
                                    :error-messages="state_errors"
                                    @input="delayTouch($v.data.state)"
                                    @blur="$v.data.company.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="Postal Code"
                                    dusk="postalCode"
                                    v-model="data.postalCode"
                                    ref="postalCode"
                                    color="primary"
                                    outline
                                    :error-messages="postalCode_errors"
                                    @input="delayTouch($v.data.postalCode)"
                                    @blur="$v.data.postalCode.$touch()"
                                    v-on:keypress="postalCodeKeyValidation($event)"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-select
                                    v-model="data.country"
                                    dusk="country"
                                    :items="countries"
                                    item-text="name"
                                    item-value="name"
                                    label="Country"
                                    color="primary"
                                    outline
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-select
                                    v-model="data.plan"
                                    dusk="plan"
                                    :items="plans"
                                    label="Software Edition"
                                    color="primary"
                                    outline
                            ></v-select>
                        </v-flex>
                        <v-flex xs12>
                            Create Your Account Login:
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Username"
                                    dusk="username"
                                    v-model="data.username"
                                    ref="username"
                                    color="primary"
                                    outline
                                    :error-messages="username_errors"
                                    @input="delayTouch($v.data.username)"
                                    @blur="$v.data.username.$touch()"
                                    autocomplete="new-password"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Password"
                                    dusk="password"
                                    v-model="data.password"
                                    ref="password"
                                    color="primary"
                                    outline
                                    hint="Password must be at least 8 characters long"
                                    min="8"
                                    :counter="60"
                                    :error-messages="password_errors"
                                    @input="delayTouch($v.data.password)"
                                    @blur="$v.data.password.$touch()"
                                    :append-icon="visible ? 'visibility' : 'visibility_off'"
                                    @click:append="() => {visible = !visible}"
                                    :type="!visible ? 'password' : 'text'"
                                    autocomplete="new-password"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Password Confirmation"
                                    v-model="data.password_confirmation"
                                    dusk="password_confirmation"
                                    ref="password_confirmation"
                                    color="primary"
                                    outline
                                    hint="Password must be at least 8 characters long"
                                    min="8"
                                    :counter="60"
                                    :error-messages="password_confirmation_errors"
                                    @input="delayTouch($v.data.password_confirmation)"
                                    @blur="$v.data.password_confirmation.$touch()"
                                    :append-icon="visible ? 'visibility' : 'visibility_off'"
                                    @click:append="() => {visible = !visible}"
                                    :type="!visible ? 'password' : 'text'"
                                    autocomplete="new-password"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-layout row wrap justify-center>
                                <v-flex xs1 id="subscriptionAgreementCheckboxContainer">
                                    <v-checkbox
                                            color="primary"
                                            v-model="data.subscriptionAgreement"
                                            ref="subscriptionAgreement"
                                            :error-messages="subscriptionAgreement_errors"
                                            @input="delayTouch($v.data.subscriptionAgreement)"
                                            @blur="$v.data.subscriptionAgreement.$touch()"
                                    >
                                    </v-checkbox>
                                </v-flex>
                                <v-flex xs11 md10>
                                    <div class="subscriptionAgreement--text">
                                        I agree to the
                                        <a href="https://vorsi-home.s3.amazonaws.com/vorsi-MSA.docx" download="vorsi-MSA.docx"
                                           style="color: #00796b; cursor: pointer">
                                            <u>
                                                Vorsi.io Subscription Agreement
                                            </u>
                                        </a>.
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-btn
                                dusk="submitTryForFreeButton"
                                style="background-image: linear-gradient(0deg, #4A148C 75%, #3A037B 86%, #311B92); margin-top: 20px"
                                @click="submit()"
                                :loading="loading"
                                large
                        > Start my free trial
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card-actions>
            <v-alert
                    dusk="alertText"
                    class="error-alert"
                    v-model="alert"
                    :type="alertType"
                    transition="scale-transition"
                    dismissible
            > {{alertMessage}}
            </v-alert>
        </v-container>
    </v-container>
</template>

<script>
    import {required, email, maxLength, minLength, sameAs, helpers} from 'vuelidate/lib/validators'
    import IconBase from '../../components/icons/IconBase.vue'
    import IconVorsiLogo from '../../components/icons/IconVorsiLogo.vue'

    const touchMap = new WeakMap();
    const regex = new RegExp(/^[+]?(([0-9]{1})[-\s.]?)?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}(x\d{0,4})?$/);
    const phoneCheck = (value) => !helpers.req(value) || regex.test(value);

    function isChecked(value) {
        return value === true;
    }

    function postalCodeCheck(value) {
        const regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        return regex.test(value) || value === 0;
    }

    export default {
        components: {
            IconBase,
            IconVorsiLogo,
        },
        props: ['tryForFree'],
        validations: {
            data: {
                firstName: {required, maxLength: maxLength(60)},
                lastName: {required, maxLength: maxLength(60)},
                jobTitle: {required, maxLength: maxLength(60)},
                email: {required, maxLength: maxLength(60), email},
                phone: {required, phoneCheck},
                company: {required, maxLength: maxLength(60)},
                streetNumber: {required, maxLength: maxLength(10)},
                streetName: {required, maxLength: maxLength(60)},
                city: {required, maxLength: maxLength(60)},
                state: {required, maxLength: maxLength(60)},
                postalCode: {required, postalCodeCheck, maxLength: maxLength(20)},
                username: {required, maxLength: maxLength(60), minLength: minLength(8)},
                password: {required, maxLength: maxLength(60), minLength: minLength(8)},
                password_confirmation: {
                    required,
                    maxLength: maxLength(60),
                    minLength: minLength(8),
                    sameAsPassword: sameAs('password')
                },
                subscriptionAgreement: {isChecked},
            }
        },
        mounted() {
            window.addEventListener('load', () => {
                let intervalID = setInterval(() => {
                    if (typeof grecaptcha !== undefined) {
                        this.getReCaptchaToken();
                        clearInterval(intervalID)
                    }
                }, 100);
            });
        },
        computed: {
            firstName_errors() {
                const errors = [];
                if (!this.$v.data.firstName.$dirty) return errors;
                !this.$v.data.firstName.required && errors.push('First Name is required.');
                !this.$v.data.firstName.maxLength && errors.push('First Name must be at most 60 characters long');
                return errors
            },
            lastName_errors() {
                const errors = [];
                if (!this.$v.data.lastName.$dirty) return errors;
                !this.$v.data.lastName.required && errors.push('Last Name is required.');
                !this.$v.data.lastName.maxLength && errors.push('Last Name must be at most 60 characters long');
                return errors
            },
            jobTitle_errors() {
                const errors = [];
                if (!this.$v.data.jobTitle.$dirty) return errors;
                !this.$v.data.jobTitle.required && errors.push('Job Title is required.');
                !this.$v.data.jobTitle.maxLength && errors.push('Job Title must be at most 60 characters long');
                return errors
            },
            email_errors() {
                const errors = [];
                if (!this.$v.data.email.$dirty) return errors;
                !this.$v.data.email.email && errors.push('Email must be valid.');
                !this.$v.data.email.required && errors.push('Email is required.');
                !this.$v.data.email.maxLength && errors.push('Email must be at most 60 characters long');
                return errors
            },
            phone_errors() {
                const errors = [];
                if (!this.$v.data.phone.$dirty) return errors;
                !this.$v.data.phone.phoneCheck && errors.push('Phone must be a valid phone number.');
                !this.$v.data.phone.required && errors.push('Phone is required.');
                return errors
            },
            company_errors() {
                const errors = [];
                if (!this.$v.data.company.$dirty) return errors;
                !this.$v.data.company.required && errors.push('Company is required.');
                !this.$v.data.company.maxLength && errors.push('Company must be at most 60 characters long');
                return errors
            },
            streetNumber_errors() {
                const errors = [];
                if (!this.$v.data.streetNumber.$dirty) return errors;
                !this.$v.data.streetNumber.required && errors.push('Street Number is required.');
                !this.$v.data.streetNumber.maxLength && errors.push('Street Number must be at most 10 characters long');
                return errors
            },
            streetName_errors() {
                const errors = [];
                if (!this.$v.data.streetName.$dirty) return errors;
                !this.$v.data.streetName.required && errors.push('Street Name is required.');
                !this.$v.data.streetName.maxLength && errors.push('Street Name must be at most 60 characters long');
                return errors
            },
            city_errors() {
                const errors = [];
                if (!this.$v.data.city.$dirty) return errors;
                !this.$v.data.city.required && errors.push('City is required.');
                !this.$v.data.city.maxLength && errors.push('City must be at most 60 characters long');
                return errors
            },
            state_errors() {
                const errors = [];
                if (!this.$v.data.state.$dirty) return errors;
                !this.$v.data.state.required && errors.push('State is required.');
                !this.$v.data.state.maxLength && errors.push('State must be at most 60 characters long');
                return errors
            },
            postalCode_errors() {
                const errors = [];
                if (!this.$v.data.postalCode.$dirty) return errors;
                !this.$v.data.postalCode.required && errors.push('Postal Code is required.');
                !this.$v.data.postalCode.maxLength && errors.push('Postal Code must be at most 20 characters long');
                !this.$v.data.postalCode.postalCodeCheck && errors.push('This is not a valid Postal Code.');
                return errors
            },
            username_errors() {
                const errors = [];
                if (!this.$v.data.username.$dirty) return errors;
                !this.$v.data.username.maxLength && errors.push('Username must be at most 30 characters long');
                !this.$v.data.username.minLength && errors.push('Username must be at least 8 characters long');
                !this.$v.data.username.required && errors.push('Username is required.');
                return errors
            },
            password_errors() {
                const errors = [];
                if (!this.$v.data.password.$dirty) return errors;
                !this.$v.data.password.maxLength && errors.push('Password must be at most 30 characters long');
                !this.$v.data.password.minLength && errors.push('Password must be at least 8 characters long');
                !this.$v.data.password.required && errors.push('Password is required.');
                return errors
            },
            password_confirmation_errors() {
                const errors = [];
                if (!this.$v.data.password_confirmation.$dirty) return errors;
                !this.$v.data.password_confirmation.maxLength && errors.push('Password Confirmation must be at most 60 characters long');
                !this.$v.data.password_confirmation.minLength && errors.push('Password Confirmation must be at least 8 characters long');
                !this.$v.data.password_confirmation.sameAsPassword && errors.push('Does not match password');
                !this.$v.data.password_confirmation.required && errors.push('Password Confirmation is required.');
                return errors
            },
            subscriptionAgreement_errors() {
                const errors = [];
                if (!this.$v.data.subscriptionAgreement.$dirty) return errors;
                !this.$v.data.subscriptionAgreement.required && errors.push('');
                return errors
            },
        },
        methods: {
            phoneKeyValidation(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && ![32, 40, 41, 43, 45, 120].includes(charCode)) evt.preventDefault();
                if (this.data.phone && this.data.phone.toString().length >= 20) evt.preventDefault();
            },
            postalCodeKeyValidation(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) evt.preventDefault();
                if (this.data.postalCode && this.data.postalCode.length >= 10) evt.preventDefault();
            },
            submit() {
                if (this.check() === false) {
                    this.loading = true;
                    axios.post('/company/register', this.data).then(response => {
                        window.location = response.data;
                    }).catch(error => {
                        this.alertType = 'error';
                        if (error.response.data.errors) this.alertMessage = error.response.data.errors[Object.keys(error.response.data.errors)[0]].toString();
                        else this.alertMessage = error.response.data.message;
                        this.alert = true;
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    let elements = [];
                    Object.keys(this.$refs).forEach(ref => {
                        if (this.$v.data[ref].$error) elements.push(ref)
                    });
                    this.alert = true;
                    this.alertType = 'error';
                    this.alertMessage = 'You have errors on the form in the field(s) ' + elements.join(', ');
                }
            },
            check() {
                this.$v.$touch();
                return this.$v.$anyError;
            },
            getReCaptchaToken() {
                grecaptcha.ready(() => {
                    grecaptcha.execute(process.env.MIX_reCAPTCHA_KEY, {action: 'homepage'})
                        .then((token) => {
                            this.data.reCaptchaToken = token
                        });
                });
            },
            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) clearTimeout(touchMap.get($v));
                touchMap.set($v, setTimeout($v.$touch, 1000))
            },
        },
        data: () => ({
            loading: false,
            alert: false,
            alertType: 'success',
            alertMessage: '',
            data: {
                firstName: '',
                lastName: '',
                jobTitle: '',
                email: '',
                phone: '',
                company: '',
                country: 'United States',
                streetNumber: '',
                streetName: '',
                city: '',
                state: '',
                postalCode: '',
                username: '',
                password: '',
                password_confirmation: '',
                plan: 1,
                reCaptchaToken: '',
                token: window.location.href.split("/").pop()
            },
            visible: false,
            subscriptionAgreement: false,
            termsOfService: false,
            plans: [
                {text: 'Basic', value: 1},
                {text: 'Professional', value: 2},
                {text: 'Business', value: 3},
                {text: 'Enterprise', value: 4}
            ],
            countries: [
                // {"name": "Afghanistan", "code": "AF"},
                // {"name": "land Islands", "code": "AX"},
                // {"name": "Albania", "code": "AL"},
                // {"name": "Algeria", "code": "DZ"},
                // {"name": "American Samoa", "code": "AS"},
                // {"name": "AndorrA", "code": "AD"},
                // {"name": "Angola", "code": "AO"},
                // {"name": "Anguilla", "code": "AI"},
                // {"name": "Antarctica", "code": "AQ"},
                // {"name": "Antigua and Barbuda", "code": "AG"},
                // {"name": "Argentina", "code": "AR"},
                // {"name": "Armenia", "code": "AM"},
                // {"name": "Aruba", "code": "AW"},
                // {"name": "Australia", "code": "AU"},
                // {"name": "Austria", "code": "AT"},
                // {"name": "Azerbaijan", "code": "AZ"},
                // {"name": "Bahamas", "code": "BS"},
                // {"name": "Bahrain", "code": "BH"},
                // {"name": "Bangladesh", "code": "BD"},
                // {"name": "Barbados", "code": "BB"},
                // {"name": "Belarus", "code": "BY"},
                // {"name": "Belgium", "code": "BE"},
                // {"name": "Belize", "code": "BZ"},
                // {"name": "Benin", "code": "BJ"},
                // {"name": "Bermuda", "code": "BM"},
                // {"name": "Bhutan", "code": "BT"},
                // {"name": "Bolivia", "code": "BO"},
                // {"name": "Bosnia and Herzegovina", "code": "BA"},
                // {"name": "Botswana", "code": "BW"},
                // {"name": "Bouvet Island", "code": "BV"},
                // {"name": "Brazil", "code": "BR"},
                // {"name": "British Indian Ocean Territory", "code": "IO"},
                // {"name": "Brunei Darussalam", "code": "BN"},
                // {"name": "Bulgaria", "code": "BG"},
                // {"name": "Burkina Faso", "code": "BF"},
                // {"name": "Burundi", "code": "BI"},
                // {"name": "Cambodia", "code": "KH"},
                // {"name": "Cameroon", "code": "CM"},
                {"name": "Canada", "code": "CA"},
                // {"name": "Cape Verde", "code": "CV"},
                // {"name": "Cayman Islands", "code": "KY"},
                // {"name": "Central African Republic", "code": "CF"},
                // {"name": "Chad", "code": "TD"},
                // {"name": "Chile", "code": "CL"},
                // {"name": "China", "code": "CN"},
                // {"name": "Christmas Island", "code": "CX"},
                // {"name": "Cocos (Keeling) Islands", "code": "CC"},
                // {"name": "Colombia", "code": "CO"},
                // {"name": "Comoros", "code": "KM"},
                // {"name": "Congo", "code": "CG"},
                // {"name": "Congo, The Democratic Republic of the", "code": "CD"},
                // {"name": "Cook Islands", "code": "CK"},
                // {"name": "Costa Rica", "code": "CR"},
                // {"name": "Cote D'Ivoire", "code": "CI"},
                // {"name": "Croatia", "code": "HR"},
                // {"name": "Cuba", "code": "CU"},
                // {"name": "Cyprus", "code": "CY"},
                // {"name": "Czech Republic", "code": "CZ"},
                // {"name": "Denmark", "code": "DK"},
                // {"name": "Djibouti", "code": "DJ"},
                // {"name": "Dominica", "code": "DM"},
                // {"name": "Dominican Republic", "code": "DO"},
                // {"name": "Ecuador", "code": "EC"},
                // {"name": "Egypt", "code": "EG"},
                // {"name": "El Salvador", "code": "SV"},
                // {"name": "Equatorial Guinea", "code": "GQ"},
                // {"name": "Eritrea", "code": "ER"},
                // {"name": "Estonia", "code": "EE"},
                // {"name": "Ethiopia", "code": "ET"},
                // {"name": "Falkland Islands (Malvinas)", "code": "FK"},
                // {"name": "Faroe Islands", "code": "FO"},
                // {"name": "Fiji", "code": "FJ"},
                // {"name": "Finland", "code": "FI"},
                // {"name": "France", "code": "FR"},
                // {"name": "French Guiana", "code": "GF"},
                // {"name": "French Polynesia", "code": "PF"},
                // {"name": "French Southern Territories", "code": "TF"},
                // {"name": "Gabon", "code": "GA"},
                // {"name": "Gambia", "code": "GM"},
                // {"name": "Georgia", "code": "GE"},
                // {"name": "Germany", "code": "DE"},
                // {"name": "Ghana", "code": "GH"},
                // {"name": "Gibraltar", "code": "GI"},
                // {"name": "Greece", "code": "GR"},
                // {"name": "Greenland", "code": "GL"},
                // {"name": "Grenada", "code": "GD"},
                // {"name": "Guadeloupe", "code": "GP"},
                // {"name": "Guam", "code": "GU"},
                // {"name": "Guatemala", "code": "GT"},
                // {"name": "Guernsey", "code": "GG"},
                // {"name": "Guinea", "code": "GN"},
                // {"name": "Guinea-Bissau", "code": "GW"},
                // {"name": "Guyana", "code": "GY"},
                // {"name": "Haiti", "code": "HT"},
                // {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
                // {"name": "Holy See (Vatican City State)", "code": "VA"},
                // {"name": "Honduras", "code": "HN"},
                // {"name": "Hong Kong", "code": "HK"},
                // {"name": "Hungary", "code": "HU"},
                // {"name": "Iceland", "code": "IS"},
                // {"name": "India", "code": "IN"},
                // {"name": "Indonesia", "code": "ID"},
                // {"name": "Iran, Islamic Republic Of", "code": "IR"},
                // {"name": "Iraq", "code": "IQ"},
                // {"name": "Ireland", "code": "IE"},
                // {"name": "Isle of Man", "code": "IM"},
                // {"name": "Israel", "code": "IL"},
                // {"name": "Italy", "code": "IT"},
                // {"name": "Jamaica", "code": "JM"},
                // {"name": "Japan", "code": "JP"},
                // {"name": "Jersey", "code": "JE"},
                // {"name": "Jordan", "code": "JO"},
                // {"name": "Kazakhstan", "code": "KZ"},
                // {"name": "Kenya", "code": "KE"},
                // {"name": "Kiribati", "code": "KI"},
                // {"name": "Korea, Democratic People'S Republic of", "code": "KP"},
                // {"name": "Korea, Republic of", "code": "KR"},
                // {"name": "Kuwait", "code": "KW"},
                // {"name": "Kyrgyzstan", "code": "KG"},
                // {"name": "Lao People'S Democratic Republic", "code": "LA"},
                // {"name": "Latvia", "code": "LV"},
                // {"name": "Lebanon", "code": "LB"},
                // {"name": "Lesotho", "code": "LS"},
                // {"name": "Liberia", "code": "LR"},
                // {"name": "Libyan Arab Jamahiriya", "code": "LY"},
                // {"name": "Liechtenstein", "code": "LI"},
                // {"name": "Lithuania", "code": "LT"},
                // {"name": "Luxembourg", "code": "LU"},
                // {"name": "Macao", "code": "MO"},
                // {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
                // {"name": "Madagascar", "code": "MG"},
                // {"name": "Malawi", "code": "MW"},
                // {"name": "Malaysia", "code": "MY"},
                // {"name": "Maldives", "code": "MV"},
                // {"name": "Mali", "code": "ML"},
                // {"name": "Malta", "code": "MT"},
                // {"name": "Marshall Islands", "code": "MH"},
                // {"name": "Martinique", "code": "MQ"},
                // {"name": "Mauritania", "code": "MR"},
                // {"name": "Mauritius", "code": "MU"},
                // {"name": "Mayotte", "code": "YT"},
                {"name": "Mexico", "code": "MX"},
                // {"name": "Micronesia, Federated States of", "code": "FM"},
                // {"name": "Moldova, Republic of", "code": "MD"},
                // {"name": "Monaco", "code": "MC"},
                // {"name": "Mongolia", "code": "MN"},
                // {"name": "Montenegro", "code": "ME"},
                // {"name": "Montserrat", "code": "MS"},
                // {"name": "Morocco", "code": "MA"},
                // {"name": "Mozambique", "code": "MZ"},
                // {"name": "Myanmar", "code": "MM"},
                // {"name": "Namibia", "code": "NA"},
                // {"name": "Nauru", "code": "NR"},
                // {"name": "Nepal", "code": "NP"},
                // {"name": "Netherlands", "code": "NL"},
                // {"name": "Netherlands Antilles", "code": "AN"},
                // {"name": "New Caledonia", "code": "NC"},
                // {"name": "New Zealand", "code": "NZ"},
                // {"name": "Nicaragua", "code": "NI"},
                // {"name": "Niger", "code": "NE"},
                // {"name": "Nigeria", "code": "NG"},
                // {"name": "Niue", "code": "NU"},
                // {"name": "Norfolk Island", "code": "NF"},
                // {"name": "Northern Mariana Islands", "code": "MP"},
                // {"name": "Norway", "code": "NO"},
                // {"name": "Oman", "code": "OM"},
                // {"name": "Pakistan", "code": "PK"},
                // {"name": "Palau", "code": "PW"},
                // {"name": "Palestinian Territory, Occupied", "code": "PS"},
                // {"name": "Panama", "code": "PA"},
                // {"name": "Papua New Guinea", "code": "PG"},
                // {"name": "Paraguay", "code": "PY"},
                // {"name": "Peru", "code": "PE"},
                // {"name": "Philippines", "code": "PH"},
                // {"name": "Pitcairn", "code": "PN"},
                // {"name": "Poland", "code": "PL"},
                // {"name": "Portugal", "code": "PT"},
                // {"name": "Puerto Rico", "code": "PR"},
                // {"name": "Qatar", "code": "QA"},
                // {"name": "Reunion", "code": "RE"},
                // {"name": "Romania", "code": "RO"},
                // {"name": "Russian Federation", "code": "RU"},
                // {"name": "RWANDA", "code": "RW"},
                // {"name": "Saint Helena", "code": "SH"},
                // {"name": "Saint Kitts and Nevis", "code": "KN"},
                // {"name": "Saint Lucia", "code": "LC"},
                // {"name": "Saint Pierre and Miquelon", "code": "PM"},
                // {"name": "Saint Vincent and the Grenadines", "code": "VC"},
                // {"name": "Samoa", "code": "WS"},
                // {"name": "San Marino", "code": "SM"},
                // {"name": "Sao Tome and Principe", "code": "ST"},
                // {"name": "Saudi Arabia", "code": "SA"},
                // {"name": "Senegal", "code": "SN"},
                // {"name": "Serbia", "code": "RS"},
                // {"name": "Seychelles", "code": "SC"},
                // {"name": "Sierra Leone", "code": "SL"},
                // {"name": "Singapore", "code": "SG"},
                // {"name": "Slovakia", "code": "SK"},
                // {"name": "Slovenia", "code": "SI"},
                // {"name": "Solomon Islands", "code": "SB"},
                // {"name": "Somalia", "code": "SO"},
                // {"name": "South Africa", "code": "ZA"},
                // {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
                // {"name": "Spain", "code": "ES"},
                // {"name": "Sri Lanka", "code": "LK"},
                // {"name": "Sudan", "code": "SD"},
                // {"name": "Suriname", "code": "SR"},
                // {"name": "Svalbard and Jan Mayen", "code": "SJ"},
                // {"name": "Swaziland", "code": "SZ"},
                // {"name": "Sweden", "code": "SE"},
                // {"name": "Switzerland", "code": "CH"},
                // {"name": "Syrian Arab Republic", "code": "SY"},
                // {"name": "Taiwan, Province of China", "code": "TW"},
                // {"name": "Tajikistan", "code": "TJ"},
                // {"name": "Tanzania, United Republic of", "code": "TZ"},
                // {"name": "Thailand", "code": "TH"},
                // {"name": "Timor-Leste", "code": "TL"},
                // {"name": "Togo", "code": "TG"},
                // {"name": "Tokelau", "code": "TK"},
                // {"name": "Tonga", "code": "TO"},
                // {"name": "Trinidad and Tobago", "code": "TT"},
                // {"name": "Tunisia", "code": "TN"},
                // {"name": "Turkey", "code": "TR"},
                // {"name": "Turkmenistan", "code": "TM"},
                // {"name": "Turks and Caicos Islands", "code": "TC"},
                // {"name": "Tuvalu", "code": "TV"},
                // {"name": "Uganda", "code": "UG"},
                // {"name": "Ukraine", "code": "UA"},
                // {"name": "United Arab Emirates", "code": "AE"},
                // {"name": "United Kingdom", "code": "GB"},
                {"name": "United States", "code": "US"},
                // {"name": "United States Minor Outlying Islands", "code": "UM"},
                // {"name": "Uruguay", "code": "UY"},
                // {"name": "Uzbekistan", "code": "UZ"},
                // {"name": "Vanuatu", "code": "VU"},
                // {"name": "Venezuela", "code": "VE"},
                // {"name": "Viet Nam", "code": "VN"},
                // {"name": "Virgin Islands, British", "code": "VG"},
                // {"name": "Virgin Islands, U.S.", "code": "VI"},
                // {"name": "Wallis and Futuna", "code": "WF"},
                // {"name": "Western Sahara", "code": "EH"},
                // {"name": "Yemen", "code": "YE"},
                // {"name": "Zambia", "code": "ZM"},
                // {"name": "Zimbabwe", "code": "ZW"}
            ]
        }),
    }
</script>


<style scoped>

</style>